module.exports = __webpack_public_path__ + "img/line.0ba1bba6.svg";